const ANTIVIRUS_MONITORING = 'Antivirus Monitoring';
const TRASH_ASSET = 'TRASH_ASSET';
const SCRIPT_TRIGGERED = 'RUN_SCRIPT';
const SCRIPT_COMPLETED = 'RUN_SCRIPT_STATUS';
const SCRIPT_SKIPPED = 'Skipped';
const STATUS_SUCCESS = 'Success';
const STATUS_FAILURE = 'Failure';
const STATUS_INSTALLED = 'Installed';
const PATCH_INSTALLATION_ROLLBACK_FAILED = 'Failed';
const PATCH_ROLLBACK_IN_PROGRESS = 'In Progress';


export {
  ANTIVIRUS_MONITORING,
  TRASH_ASSET,
  SCRIPT_TRIGGERED,
  SCRIPT_COMPLETED,
  STATUS_SUCCESS,
  STATUS_FAILURE,
  STATUS_INSTALLED,
  SCRIPT_SKIPPED,
  PATCH_ROLLBACK_IN_PROGRESS,
  PATCH_INSTALLATION_ROLLBACK_FAILED
};
